(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pfp-intention-form"] && !Shopify.designMode) return;
  try {
    const prayerMobileScreen = window.matchMedia('(max-width: 749px)');
  let originalWithdrawalParent;
  function placePrayerWithdrawalLink() {
    const slot = document.querySelector('.pfp-withdrawal-slot');
    const link = document.querySelector('a.eu-withdrawal-fab');
    if (!slot || !link) return false;
    if (!originalWithdrawalParent) originalWithdrawalParent = link.parentElement;
    if (prayerMobileScreen.matches && link.parentElement !== slot) slot.append(link);
    if (!prayerMobileScreen.matches && link.parentElement === slot) originalWithdrawalParent.append(link);
    return true;
  }
  prayerMobileScreen.addEventListener('change', placePrayerWithdrawalLink);
  if (!placePrayerWithdrawalLink()) {
    const withdrawalObserver = new MutationObserver(() => {
      if (placePrayerWithdrawalLink()) withdrawalObserver.disconnect();
    });
    withdrawalObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => withdrawalObserver.disconnect(), 15000);
  }
  document.addEventListener('shopify:section:load', placePrayerWithdrawalLink);
  } catch(e) { console.error(e); }
})();

})();
